export default __webpack_public_path__ + "static/media/br.f3cc26fa.svg";